import { Datepicker } from 'vanillajs-datepicker';

// Every picker adds a document mousedown and a window resize listener that only destroy() removes, and both outlive
// Turbo visits. This runs on every turbo:load and again whenever nested fields are added to a page, so pickers whose
// input has left the page are destroyed, and an input that already has a picker keeps it.
const pickers = new Set();

const destroyDetachedPickers = () => {
  pickers.forEach((picker) => {
    if (picker.inputField?.isConnected) return;
    picker.destroy();
    pickers.delete(picker);
  });
};

// Dropdowns no live picker owns (for example copies in a restored Turbo snapshot) would stack up on the page.
const removeStrayDropdowns = () => {
  const owned = new Set([...pickers].map((picker) => picker.picker?.element));
  document.querySelectorAll('.datepicker.datepicker-dropdown').forEach((dropdown) => {
    if (!owned.has(dropdown)) dropdown.remove();
  });
};

const initializeDatepickers = () => {
  destroyDetachedPickers();
  const datepickers = document.querySelectorAll('[data-datepicker]');
  if (!datepickers.length) return;

  removeStrayDropdowns();
  const sharedOptions = {
    buttonClass: 'btn',
    format: 'y-mm-dd',
  };
  datepickers.forEach((input) => {
    if (input.datepicker) return;
    const options = JSON.parse(input.dataset.datepicker);
    if (options.maxDate === 'today') options.maxDate = new Date();
    pickers.add(new Datepicker(input, { ...sharedOptions, ...options }));
  });
};

export default initializeDatepickers;
